export const LARGE = '660px'
export const CAROUSEL_INTERVAL = 5000
